<template>
  <div>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <h4>Education</h4>
      <vs-tooltip text="Add" color="primary">
        <vs-button
          type="border"
          color="primary"
          icon="add"
          @click="canAdd()"
        />
      </vs-tooltip>
    </div>
    <div class="table-responsive">
      <table v-if="educationProps.length > 0" class="light_blue_table w-full">
        <tbody>
          <tr :key="indextr" v-for="(item, indextr) in educationProps">
            <td>
              <div v-if="item.certificate_picture">
                <div v-if="item.certificate_picture.includes('.pdf')">
                  <img
                  style="width: 40px; height: 40px"
                  src="@/assets/images/file-icons/pdf.png"
                />
                </div>
                <img
                  v-else
                  style="width: 40px; height: 40px"
                  :src="item.certificate_picture"
                />
              </div>
              <img
                v-else
                style="width: 40px; height: 40px"
                src="@/assets/images/placeholder.png"
              />
            </td>
            <td>
              {{ item.institute }}
            </td>

            <td>
              {{ item.degree }}
            </td>
            <td>
              {{ item.start_from | moment("MMM-YYYY") }}
            </td>
            <td>
              <span v-if="item.still_studying === 0">
                {{ item.end_to | moment("MMM-YYYY") }}
              </span>
            </td>
            <td class="text-right">
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item v-if="item.certificate_picture">
                    <a
                      v-if="item.certificate_picture"
                      :href="item.certificate_picture"
                      target="_blank"
                      >Preview
                    </a>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleedit(indextr)">
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="remove(indextr)">
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="educationProps.length == 0" class="text-center">
        No Education found
      </div>
    </div>

    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-if="addEducation"
      :class="{ show: addEducation }"
    >
      <div class="cstm-modal">
        <div class="header">
          <h4>Add Education</h4>
          <button @click="addEducation = false" class="close-modal">
            &times;
          </button>
        </div>
        <form data-vv-scope="add">
          <div class="p-4 modal-content">
            <vs-input
              v-validate="'required'"
              name="institute"
              v-model="education.institute"
              label="Institution Name"
              placeholder="Enter Institution Name"
              class="w-full mb-4"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.institute')" class="text-danger">{{
              errors.first("add.institute")
            }}</span>
            <vs-input
              label="Degree"
              placeholder="Enter Degree"
              v-validate="'required'"
              name="degree"
              v-model="education.degree"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
              class="w-full mb-4"
            />
            <span v-show="errors.has('add.degree')" class="text-danger">{{
              errors.first("add.degree")
            }}</span>
            <div class="flex justify-between items-center my-5">
              <div class="inline-flex items-center">
                <span class="mr-4">Still Studying</span>
                <vs-switch
                  v-validate="'required'"
                  :options="option"
                  label="label"
                  name="still-studying"
                  :reduce="(option) => option.value"
                  v-model="education.still_studying"
                />
                <span
                  v-show="errors.has('still-studying')"
                  class="text-danger"
                  >{{ errors.first("still-studying") }}</span
                >
              </div>
              <div>
                <span style="font-size: 11px">From</span>
                <datepicker
                  v-validate="'required'"
                  name="from"
                  :minimumView="'month'"
                  :maximumView="'year'"
                  :disabled-dates="disabledDates"
                  format="MM-yyyy"
                  v-model="education.start_from"
                  class="w-full right_datepicker"
                />
                <span v-show="errors.has('add.from')" class="text-danger">{{
                  errors.first("add.from")
                }}</span>
              </div>
              <div v-if="!education.still_studying">
                <span style="font-size: 11px">To</span>
                <datepicker
                  v-validate="'required'"
                  name="to"
                  :minimumView="'month'"
                  :maximumView="'year'"
                  :disabled-dates="disabledDates1"
                  format="MM-yyyy"
                  v-model="education.end_to"
                  class="w-full right_datepicker"
                />
                <span v-show="errors.has('add.to')" class="text-danger">{{
                  errors.first("add.to")
                }}</span>
              </div>
            </div>
            <h6 class="font-semibold mb-2">Upload Certificate</h6>
            <div class="upload_holder mb-4">
              <FileUpload
                :platform_module_id="4"
                @changingImage="saveImage"
              ></FileUpload>

              <!-- <div style="background: #EBFEFF; border: 1px dashed #00CFDD; border-radius: 6px;" class="text-center p-6">
                        <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 20H68V48H76V20C76 15.588 72.412 12 68 12H16C11.588 12 8 15.588 8 20V68C8 72.412 11.588 76 16 76H48V68H16V20Z" fill="#C4E2E3"/>
                            <path d="M32 44L20 60H64L48 36L36 52L32 44Z" fill="#C4E2E3"/>
                            <path d="M76 56H68V68H56V76H68V88H76V76H88V68H76V56Z" fill="#C4E2E3"/>
                        </svg>
                        <p style="color: #5C7C7D;">Upload file</p>
                    </div> -->
            </div>
            <div
              style="border-top: 1px solid #cecece"
              class="flex flex-wrap justify-between items-center pt-4"
            >
              <vs-button
                type="border"
                color="danger"
                class="m-1"
                @click="addEducation = false"
                >Cancel</vs-button
              >
              <vs-button class="m-1" @click.prevent="handleSave"
                >Save</vs-button
              >
            </div>
          </div>
        </form>
      </div>
    </div>

    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-if="editEducation"
      :class="{ show: editEducation }"
    >
      <div class="cstm-modal">
        <div class="header">
          <h4>Edit Education</h4>
          <button @click="editEducation = false" class="close-modal">
            &times;
          </button>
        </div>
        <form data-vv-scope="edit">
          <div class="p-4 modal-content">
            <vs-input
              v-validate="'required'"
              name="institute"
              v-model="edit.institute"
              label="Institution Name"
              placeholder="Enter Institution Name"
              class="w-full mb-4"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.institute')" class="text-danger">{{
              errors.first("edit.institute")
            }}</span>
            <vs-input
              label="Degree"
              placeholder="Enter Degree"
              v-validate="'required'"
              name="degree"
              v-model="edit.degree"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
              class="w-full mb-4"
            />
            <span v-show="errors.has('edit.degree')" class="text-danger">{{
              errors.first("edit.degree")
            }}</span>
            <div class="flex justify-between items-center my-5">
              <div class="inline-flex items-center">
                <span class="mr-4">Still Studying</span>
                <vs-switch
                  v-validate="'required'"
                  :options="option"
                  label="label"
                  name="still-studying"
                  :reduce="(option) => option.value"
                  v-model="edit.still_studying"
                />
                <span
                  v-show="errors.has('edit.still-studying')"
                  class="text-danger"
                  >{{ errors.first("edit.still-studying") }}</span
                >
              </div>
              <div>
                <span style="font-size: 11px">From</span>
                <datepicker
                  v-validate="'required'"
                  name="from"
                  :minimumView="'month'"
                  :maximumView="'year'"
                  :disabled-dates="disabledDates"
                  format="MM-yyyy"
                  v-model="edit.start_from"
                  class="w-full right_datepicker"
                />
                <span v-show="errors.has('edit.from')" class="text-danger">{{
                  errors.first("edit.from")
                }}</span>
              </div>
              <div v-if="!edit.still_studying">
                <span style="font-size: 11px">To</span>
                <datepicker
                  v-validate="'required'"
                  name="to"
                  value="date"
                  :minimumView="'month'"
                  :maximumView="'year'"
                  :disabled-dates="disabledDates"
                  format="MM-yyyy"
                  v-model="edit.end_to"
                  class="w-full right_datepicker"
                />
                <span v-show="errors.has('edit.to')" class="text-danger">{{
                  errors.first("edit.to")
                }}</span>
              </div>
            </div>
            <h6 class="font-semibold mb-2">Upload Certificate</h6>
            <div class="upload_holder mb-4">
              <FileUpload
                :platform_module_id="4"
                :image="edit.certificate_picture"
                @changingImage="saveImageedit"
              ></FileUpload>
            </div>
            <div
              style="border-top: 1px solid #cecece"
              class="flex flex-wrap justify-between items-center pt-4"
            >
              <vs-button
                type="border"
                color="danger"
                class="m-1"
                @click="editEducation = false"
                >Cancel</vs-button
              >
              <vs-button class="m-1" @click.prevent="handleUpdate"
                >Save</vs-button
              >
            </div>
          </div>
        </form>
      </div>
    </div>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import FileUpload from '@/views/pages/v1/user_profile/components/profile/personal_information/certificateFile.vue'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import { updateClient } from '@/api/client'
export default {
  components: {
    Datepicker,
    vSelect,
    FileUpload
  },
  props: {
    educationProps: {
      required: true,
      type: Array,
      default: () => []
    },
    clientDetails: {
      default: null
    },
    educationAvailability: []
  },
  data () {
    return {
      showMore: true,
      addEducation: false,
      editEducation: false,
      studying: true,
      disabledDates: null,
      disabledDates1: null,
      deletepopup: false,
      education: {
        certificate_picture: null,
        degree: null,
        institute: null,
        still_studying: 1,
        start_from: null,
        end_to: null
      },
      edit: {
        certificate_picture: null,
        degree: null,
        institute: null,
        still_studying: null,
        start_from: null,
        end_to: null
      },
      editIndex: null,
      deleteindex: false,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      imageDataUrl: null,
      option: [
        {
          label: 'Yes',
          value: 1
        },
        {
          label: 'No',
          value: 0
        }
      ],
      fileName: ''
    }
  },
  mounted () {
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()

    this.disabledDates = {
      from: new Date(year, month)
    }
  },
  watch: {
    educationProps: {
      deep: true,
      immediate: true,
      handler () {
        this.educationAvailability = this._.cloneDeep(this.educationProps)
      }
    },
    education: {
      deep: true,
      immediate: true,
      handler () {
        if (this.education.start_from) {
          this.disabledDates1 = {
            to: this.education.start_from
          }
        }
      }
    }
  },
  methods: {
    canAdd () {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.addEducation = true
    },
    saveImage (url) {
      console.log(url)
      this.education.certificate_picture = url
    },
    saveImageedit (url) {
      this.edit.certificate_picture = url
    },
    handlePhonedefault (index) {
      this.educationAvailability.map((item) => {
        item.default = 0
      })
      this.educationAvailability[index].default = 1
    },
    handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const __temp = this.education
          __temp.start_from = this.formatDate(__temp.start_from)
          __temp.end_to =
            this.education.still_studying === false
              ? this.formatDate(__temp.end_to)
              : null
          __temp.certificate_picture = this.education.certificate_picture
          this.educationAvailability.push(__temp)
          this.educationProps = this.educationAvailability
          this.handleEducationsave()
        }
      })
    },
    async handleEducationsave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            education: this.educationAvailability
          }
        }
        const { data } = await updateClient(this.clientDetails.basic_details.client_users_id ? this.clientDetails.basic_details.client_users_id : this.clientDetails.basic_details.id, payload, customer_id)
        this.addEducation = false
        this.editEducation = false

        this.education = {
          certificate_picture: null,
          degree: null,
          institute: null,
          still_studying: 1,
          start_from: null,
          end_to: null
        }

        this.$emit('setAfterUpdate', data)
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    handleedit (index) {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editEducation = true
      const temp = this.educationAvailability[index]
      this.edit.year_from = `${temp.month_from}-${temp.year_from}`
      this.edit.year_to = `${temp.month_to}-${temp.year_to}`
      this.edit = temp
      this.editIndex = index
    },
    handleUpdate () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          const payload = this.edit
          this.educationAvailability[this.editIndex] = payload
          this.educationProps = this.educationAvailability
          this.handleEducationsave()
        }
      })
    },
    handleDelete () {
      this.handleEducationsave()

      this.educationAvailability.splice(this.deleteindex, 1)
      this.deletepopup = false
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    uploadImg (e, num) {
      const file = e.target.files[0]
      const FileType = file.type
      this.fileName = FileType.replace('/', '.')
      const fileSize = e.target.files[0].size / 1024 / 1024
      if (fileSize < 5) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const formData = new FormData()
          formData.append('myFile', file)
          let data = null
          if (typeof e.target.result === 'object') {
            data = new Blob([e.target.result])
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.imageDataUrl = data
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        reader.readAsArrayBuffer(file)
        //
      } else {
        this.option.img = ''

        this.dialogVisible = false
        this.$vs.notify({
          title: 'warning',
          text: 'Image sie is too large',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
    },

    formatDate (date) {
      const d = new Date(date)
      let month = `${d.getMonth() + 1}`
      let day = `${d.getDate()}`
      const year = `${d.getFullYear()}`
      if (month.length < 9) {
        month = `0${month}`
      }
      if (day.length < 2) {
        day = `0${day}`
      }
      return [year, month, day].join('-')
    }
  }
}
</script>